

export default () => {
	if(!window._tbpe) return;
	window._tbpe('get')('uuid')(uuid => {
		window.dataLayer.push({
			'userID' : uuid
		});
		window.dataLayer.push({
			'event' : 'UserIDLoaded'
		});
	});		
};
